import { mockManagerLayout } from '../../mocks/mock-layout';

/**
 * Serve GET /layout menu and POST /menu from local mocks (menu state kept in memory).
 * Set to `true` locally to demo without backend support; keep `false` in commits.
 */
export const USE_MENU_MOCKS = false;

const MOCK_LAYOUT_DELAY_MS = 400;

/** @type {ApiManagerMenu} */
let mockMenuState = structuredClone(mockManagerLayout.menu);

/**
 * @param {number} ms
 * @returns {Promise<void>}
 */
function delay(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

/**
 * Apply POST /menu flags onto the menu tree (matching ids level by level).
 * @param {ApiManagerMenuItem[] | null} items
 * @param {ApiPartialMenuItem[] | null} partialItems
 * @returns {ApiManagerMenuItem[] | null}
 */
function applyPartialMenuItems(items, partialItems) {
  if (!items || !partialItems) return items;

  return items.map((item) => {
    const partial = partialItems.find(({ id }) => id === item.id);
    if (!partial) return item;
    return {
      ...item,
      config: { ...item.config, available: partial.available, favorite: partial.favorite },
      items: applyPartialMenuItems(item.items, partial.items),
    };
  });
}

/**
 * Mock GET /layout: real breadcrumb/user shape with the in-memory menu.
 * @returns {Promise<ApiManagerLayout>}
 */
export async function getLayoutMock() {
  await delay(MOCK_LAYOUT_DELAY_MS);
  return { ...mockManagerLayout, menu: structuredClone(mockMenuState) };
}

/**
 * Mock POST /menu: persist flags in memory and return the updated menu.
 * @param {ApiMenuPostRequest} data
 * @returns {Promise<ApiMenuPostResponse>}
 */
export async function postMenuMock(data) {
  await delay(MOCK_LAYOUT_DELAY_MS);
  mockMenuState = {
    ...mockMenuState,
    items: applyPartialMenuItems(mockMenuState.items, data.menu.items) ?? [],
    bottomSection: {
      items: applyPartialMenuItems(mockMenuState.bottomSection.items, data.menu.bottomSection.items) ?? [],
    },
  };
  return { menu: structuredClone(mockMenuState) };
}
